import React from "react";
import { Card, Box, Typography } from "@mui/material";
import useFetchVersions from "../utils/customHookVersions";

const VersionCard = ({ logo1, logo2, size = 100 }) => {
  const { wpVersion, phpVersion, isLoading, error } = useFetchVersions();

  const logoSize = size * 0.37;

  return (
    <Card
      sx={{
        width: size + 78,
        height: size,
        p: 2,
        boxSizing: "border-box",
        display: "grid",
        gridTemplateAreas: `
          "title title"
          "logo1 version1"
          "logo2 version2"
        `,
        gridTemplateColumns: "0.7fr 1fr",
        gridTemplateRows: "auto 1fr 1fr",
        alignItems: "center",
        justifyItems: "center",
        borderRadius: 2,
        position: "relative",
      }}
    >
      <Typography
        variant="title"
        sx={{
          gridArea: "title",
          textAlign: "center",
          fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.8rem" },
          mb:"8px",
          mt:"-10px",
        }}
      >
        Dernières versions
      </Typography>

      <Box
        component="img"
        src={logo1}
        alt="logo1"
        sx={{
          gridArea: "logo1",
          width: logoSize,
          height: logoSize,
          objectFit: "contain",
          filter: "grayscale(100%)",
        }}
      />

      <Typography
        variant="subtitle1"
        sx={{
          gridArea: "version1",
          textAlign: "center",
          fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" },
        }}
      >
        {isLoading ? "Chargement..." : error ? "Erreur" : wpVersion || "N/A"}
      </Typography>

      <Box
        component="img"
        src={logo2}
        alt="logo2"
        sx={{
          gridArea: "logo2",
          width: logoSize,
          height: logoSize,
          objectFit: "contain",
          filter: "grayscale(100%)",
        }}
      />

      <Typography
        variant="subtitle1"
        sx={{
          gridArea: "version2",
          textAlign: "center",
          fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" },
        }}
      >
        {isLoading ? "" : error ? "Erreur" : phpVersion || "N/A"}
      </Typography>
    </Card>
  );
};

export default VersionCard;
